const eva_domestic = {
    welcome: 'Welcome to EVA Audio',
    phone_login: 'Phone sign-in',
    password_login: 'Password sign-in',
    agreement_prefix: 'By signing in or creating an account, you agree to',
    terms: 'Terms of Use',
    agreement_and: ' and ',
    privacy: 'Privacy Policy',
    hide_password: 'Hide password',
    show_password: 'Show password',
    invalid_identifier: 'Enter a valid email address or phone number.',
    empty_password: 'Enter your password.',
    identifier_placeholder: 'Email address or phone number',
    signing_in: 'Signing in',
    sign_in: 'Sign in',
    forgot_password: 'Forgot password?',
    invalid_phone: 'Enter a valid phone number.',
    verification_failed: 'Code verification failed. Please try again.',
    request_code_first: 'Request a verification code first.',
    invalid_code: 'Enter a valid verification code.',
    sending: 'Sending',
    resend: 'Resend code',
    send_code: 'Send code',
    phone_placeholder: 'Phone number',
    code_placeholder: 'Verification code',
    sign_in_or_register: 'Sign in / Sign up',
    email_placeholder: 'Email address',
    new_password_placeholder: 'Password (8–20 characters)',
    confirm_password_placeholder: 'Confirm password',
    submitting: 'Submitting',
    reset_password: 'Reset password',
    back_to_sign_in: 'Back to sign in',
    invalid_email: 'Enter a valid email address.',
    invalid_phone_length: 'Enter a valid 11-digit phone number.',
    invalid_reset_code: 'Enter a valid verification code.',
    password_mismatch: 'Passwords do not match.',
    account_not_registered: 'This account is not registered.',
    verification_expired: 'Verification has expired. Request a new code.',
    password_updated: 'Password updated. Sign in again.',
    phone_reset: 'Reset via phone',
    email_reset: 'Reset via email',
    countdown: '{{seconds}}s',
};
export default Object.freeze(eva_domestic);
